import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from '../../../helpers/api_helper';
import { changeRequisitionStatusFailure, changeRequisitionStatusSuccess } from './actions';

function* fetchRecruitmentRequisitionSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append('unit_id', payload.unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_RECRUITMENT_REQUISITION, formData);

    if (response.status !== 'success') throw new Error(response.message || 'Fetch failed');

    yield put({ type: types.FETCH_RECRUITMENT_REQUISITION_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_RECRUITMENT_REQUISITION_FAILURE, payload: error });
  }
}

// Save Requisition
function* saveRecruitmentRequisitionSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_RECRUITMENT_REQUISITION, payload);

    if (response.status !== 'success') throw new Error(response.message || 'Save failed');

    yield put({ type: types.SAVE_RECRUITMENT_REQUISITION_SUCCESS });
    Swal.fire('Success', response?.message || 'Saved successfully', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_RECRUITMENT_REQUISITION_FAILURE, payload: error });
  }
}

function* changeRequisitionStatusSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_STATUS_RECRUITMENT_REQUISITION, payload);

    if (response.status !== 'success') throw new Error(response.message || 'Save failed');

    yield put(changeRequisitionStatusSuccess(response));
    Swal.fire('Success', response?.message || 'Saved successfully', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put(changeRequisitionStatusFailure(error.message));
  }
}

// Root saga for Recruitment Requisition
export default function* recruitmentRequisitionSaga() {
  yield takeLatest(types.FETCH_RECRUITMENT_REQUISITION_REQUEST, fetchRecruitmentRequisitionSaga);
  yield takeLatest(types.SAVE_RECRUITMENT_REQUISITION_REQUEST, saveRecruitmentRequisitionSaga);
  yield takeLatest(types.CHANGE_REQUISITION_STATUS_REQUEST, changeRequisitionStatusSaga);
}